export enum EXERCISE_CATEGORIES {
  MOVILIDAD = 'movilidad',
  ACTIVACION = 'activación',
  PLIOMETRIA = 'pliometría',
  FUERZA = 'fuerza',
  ESTIRAMIENTOS = 'estiramientos',
  COORDINACION = 'coordinación',
  BRAKING = 'braking',
}

export enum MUSCLE_GROUPS {
  PECHO = 'pecho',
  ESPALDA = 'espalda',
  HOMBROS = 'hombros',
  BICEPS = 'bíceps',
  TRICEPS = 'tríceps',
  CUADRICEPS = 'cuádriceps',
  ISQUIOTIBIALES = 'isquiotibiales',
  GLUTEOS = 'glúteos',
  ABDOMINALES = 'abdominales',
  GEMELOS = 'gemelos',
  ANTEBRAZOS = 'antebrazos',
  LUMBARES = 'lumbares',
  ADUCTORES = 'aductores',
  ABDUCTORES = 'abductores',
  TOBILLO = 'tobillo',
  BODY = 'cuerpo completo',
  MIEMBROS_INFERIORES = 'miembros inferiores',
}
